export default "__VITE_ASSET__Cg$HpABS__"